import React, { useState, useEffect } from "react";
// First Table

const TotalReturns = (props) => {
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  return (
    <section id="total-returns">
      {screenSize.dynamicWidth < 900 ? (
        <div>
          <div
            className="total-return-img-wrapper"
            style={{ marginTop: "80px" }}
          >
            <div>
              <h1 className="sub-header t-center m-b-0">
                Total Returns (Annualized)<sup className="small-sup">3</sup>
              </h1>
              {props.as_of_date != null ? (
                <p className="t-center" style={{ marginTop: "0" }}>
                  As of {props.as_of_date}
                </p>
              ) : null}
            </div>
          </div>
          <div
            className="t-center"
            style={{ borderBottom: "1px solid black", padding: "0 30px 40px" }}
          >
            <h2 className="sub-header m-b-0">{props.class}</h2>
            {props.class !== "Class I" ? (
              <p className="m-t-0">No Sales Load</p>
            ) : null}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                marginTop: "25px",
              }}
            >
              <div>
                <p className="m-t-0">YTD</p>
                {props.data.ytd_return_percent != null ? (
                  <p className="m-0 fw-5">{props.data.ytd_return_percent}%</p>
                ) : (
                  <p className="m-0 fw-5">N/A</p>
                )}
              </div>
              <div>
                <p className="m-t-0">1 Year</p>
                {props.data.yr1_return_percent != null ? (
                  <p className="m-0 fw-5">{props.data.yr1_return_percent}%</p>
                ) : (
                  <p className="m-0 fw-5">N/A</p>
                )}
              </div>
              <div>
                <p className="m-t-0">3 Year</p>
                {props.data.yr3_return_percent != null ? (
                  <p className="m-0 fw-5">{props.data.yr3_return_percent}%</p>
                ) : (
                  <p className="m-0 fw-5">N/A</p>
                )}
              </div>
              <div>
                <p className="m-t-0">ITD</p>
                {props.data.itd_return_percent != null ? (
                  <p className="m-0 fw-5">{props.data.itd_return_percent}%</p>
                ) : (
                  <p className="m-0 fw-5">N/A</p>
                )}
              </div>
            </div>
          </div>
          {props.load !== "0.00" && props.class !== "Class I" ? (
            <div
              className="t-center"
              style={{
                borderBottom: "1px solid black",
                padding: "30px",
              }}
            >
              <h2 className="sub-header m-b-0">{props.class}</h2>
              <p className="m-t-0">With Sales Load*</p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  marginTop: "25px",
                }}
              >
                <div>
                  <p className="m-t-0">YTD</p>
                  {props.data.ytd_with_sales_load_return_percent != null ? (
                    <p className="m-0 fw-5">
                      {props.data.ytd_with_sales_load_return_percent}%
                    </p>
                  ) : (
                    <p className="m-0 fw-5">N/A</p>
                  )}
                </div>
                <div>
                  <p className="m-t-0">1 Year</p>
                  {props.data.yr1_with_sales_load_return_percent != null ? (
                    <p className="m-0 fw-5">
                      {props.data.yr1_with_sales_load_return_percent}%
                    </p>
                  ) : (
                    <p className="m-0 fw-5">N/A</p>
                  )}
                </div>
                <div>
                  <p className="m-t-0">3 Year</p>
                  {props.data.yr3_with_sales_load_return_percent != null ? (
                    <p className="m-0 fw-5">
                      {props.data.yr3_with_sales_load_return_percent}%
                    </p>
                  ) : (
                    <p className="m-0 fw-5">N/A</p>
                  )}
                </div>

                <div>
                  <p className="m-t-0">ITD</p>
                  {props.data.itd_with_sales_load_return_percent != null ? (
                    <p className="m-0 fw-5">
                      {props.data.itd_with_sales_load_return_percent}%
                    </p>
                  ) : (
                    <p className="m-0 fw-5">N/A</p>
                  )}
                </div>
              </div>
            </div>
          ) : null}
          {props.class !== "Class I" ? (
            <div className="main-padding">
              <p
                style={{
                  marginTop: "35px",
                  fontWeight: "500",
                  marginBottom: "0",
                }}
              >
                Note: Past performance is historical and not a guarantee of
                future results.
              </p>
              {props.load !== "0.00" ? (
                <p style={{ marginTop: "0" }}>
                  * Assumes payment of the full upfront {props.load}% selling
                  commissions at initial subscription.
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
      ) : (
        <div class="main-padding">
          <div class="main-margin">
            <div className="mb-10">
              <h1 className="sub-header">
                Total Returns (Annualized)<sup className="small-sup">3</sup>
              </h1>
              {props.data.as_of_date != null ? (
                <p>As of {props.data.as_of_date}</p>
              ) : null}
            </div>
          </div>
          <div class="main-margin table-shadow-main">
            <table className="odtable-header">
              <tr>
                <th className="odtable-tableheader"></th>
                <th className="odtable-tableheader">YTD</th>
                <th className="odtable-tableheader">1 Year</th>
                <th className="odtable-tableheader">3 Year</th>
                <th className="odtable-tableheader">ITD</th>
              </tr>
              <tr>
                <td className="fw-6" style={{ width: "50%" }}>
                  {props.class}{" "}
                  {props.class !== "Class I" ? "(No Sales Load)" : null}
                </td>
                {props.data.ytd_return_percent != null ? (
                  <td>{props.data.ytd_return_percent}%</td>
                ) : (
                  <td>N/A</td>
                )}
                {props.data.yr1_return_percent != null ? (
                  <td>{props.data.yr1_return_percent}%</td>
                ) : (
                  <td>N/A</td>
                )}
                {props.data.yr3_return_percent != null ? (
                  <td>{props.data.yr3_return_percent}%</td>
                ) : (
                  <td>N/A</td>
                )}
                {props.data.itd_return_percent != null ? (
                  <td>{props.data.itd_return_percent}%</td>
                ) : (
                  <td>N/A</td>
                )}
              </tr>
              {props.load !== "0.00" && props.class !== "Class I" ? (
                <tr>
                  <td className="fw-6" style={{ width: "50%" }}>
                    {props.class} (With Sales Load)*
                  </td>
                  {props.data.ytd_with_sales_load_return_percent != null ? (
                    <td>{props.data.ytd_with_sales_load_return_percent}%</td>
                  ) : (
                    <td>N/A</td>
                  )}
                  {props.data.yr1_with_sales_load_return_percent != null ? (
                    <td>{props.data.yr1_with_sales_load_return_percent}%</td>
                  ) : (
                    <td>N/A</td>
                  )}
                  {props.data.yr3_with_sales_load_return_percent != null ? (
                    <td>{props.data.yr3_with_sales_load_return_percent}%</td>
                  ) : (
                    <td>N/A</td>
                  )}
                  {props.data.itd_with_sales_load_return_percent != null ? (
                    <td>{props.data.itd_with_sales_load_return_percent}%</td>
                  ) : (
                    <td>N/A</td>
                  )}
                </tr>
              ) : null}
            </table>
          </div>
          {props.class !== "Class I" ? (
            <div className="main-margin">
              <p
                style={{
                  marginTop: "35px",
                  fontWeight: "500",
                  marginBottom: "0",
                }}
              >
                Note: Past performance is historical and not a guarantee of
                future results.
              </p>
              {props.load !== "0.00" ? (
                <p style={{ marginTop: "0" }}>
                  * Assumes payment of the full upfront {props.load}% selling
                  commissions at initial subscription.
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
      )}
    </section>
  );
};

export default TotalReturns;
